import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { INotification } from '../../../core/interfaces/notification';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private _baseUrl = `${environment.apiURL}/api`;
  public get baseUrl() {
    return this._baseUrl;
  }
  public set baseUrl(value) {
    this._baseUrl = value;
  }
  private notificationCountSource = new BehaviorSubject<number>(null);
  private notificationSource = new BehaviorSubject<INotification>(null);
  notificationCount$ = this.notificationCountSource.asObservable();
  notification$ = this.notificationSource.asObservable();
  private notificationTotalCountSource = new BehaviorSubject<number>(null);
  notificationTotalCount = this.notificationTotalCountSource.asObservable();
  constructor(private http: HttpClient, private authService: AuthService) { }

  currentUser = this.authService.currentUserValue;


  getNotifications(pageIndex = 0, pageSize = 30, pagination = true){
    return this.http.get<any>(`${this._baseUrl}/notification/${this.currentUser.id}?pageIndex=${pageIndex}&pageSize=${pageSize}&pagination=${pagination}`).pipe(
      map( (response: any) => {
        this.notificationCountSource.next(response.data.notifications.length);
        this.notificationSource.next(response.data.notifications);
        this.notificationTotalCountSource.next(response.data.count);
        return response;
      })
    );
  }

  // readNotification(id: number){
  //   const params = new HttpParams().set("id", id);
  //   return this.http.patch(`${this._baseUrl}/notification/read`,{params: params});
  // }

  // readAll(){
  //   this.notificationCountSource.next(0);
  //   this.notificationSource.next(null);
  //   return this.http.patch(`${this._baseUrl}/notification/read/${this.currentUser.id}/all`,{});
  // }

  notifyDrivers(notifyDriversDto) {
    return this.http.post<any>(`${this._baseUrl}/notification/notify/drivers`, notifyDriversDto);
  }

  getUnreadNotificationsCount(userId: string){
    return this.http.get<any>(`${this._baseUrl}/notification/GetUserNotificationsUnReadCount/${userId}`)
  }

  getUserNotifications(userId: string) {
    return this.http.get<any>(`${this._baseUrl}/notification/GetUserNotifications/${userId}`).pipe(
      map( (response: any) => {
        // // debugger;
        this.notificationCountSource.next(response.data.notifications.length);
        this.notificationSource.next(response.data.notifications);
        this.notificationTotalCountSource.next(response.data.count);
        return response;
      })
    );
  }

  readAllNotifications(userId: string) {
    // // debugger;
    this.notificationCountSource.next(0);
    this.notificationSource.next(null);
    return this.http.patch(`${this.baseUrl}/notification/Read/${userId}/All`, {});
  }

  readNotification(id: number) {
    return this.http.patch(`${this.baseUrl}/notification/Read/${id}`, {});
  }

}
